import { format } from 'date-fns';
import { Row, Text } from '~/commonComponents';
import CloseIcon from '~/images/icons/CloseIcon';
import { Colors } from '~/themes/colors';

interface ISelectedDatePillProps {
  date: Date;
  onRemove: () => void;
}

export const SelectedDatePill = ({ date, onRemove }: ISelectedDatePillProps) => {
  return (
    <Row
      data-testid="selected-date-pill"
      data-cy="selected-date-pill"
      alignItems="center"
      gap={8}
      style={{
        maxWidth: 190,
        backgroundColor: Colors.primary_50,
        border: `1.5px solid ${Colors.secondary_500}`,
        borderRadius: 36,
        height: 38,
        padding: '0px 12px',
        animation: 'pillFadeIn 0.25s ease-out',
      }}
    >
      <Text fontSize={16} fontWeight={400} style={{ whiteSpace: 'nowrap' }}>
        {format(date, 'EEE, MMM dd, yyyy')}
      </Text>
      <Row
        data-testid="remove-date"
        data-cy="remove-date"
        onClick={onRemove}
        alignItems="center"
        style={{ cursor: 'pointer' }}
      >
        <CloseIcon color={Colors.secondary_500} width={16} height={16} />
      </Row>
    </Row>
  );
};
